import { render, staticRenderFns } from "./centerBottom.vue?vue&type=template&id=6c333e54&scoped=true&"
import script from "./centerBottom.vue?vue&type=script&lang=js&"
export * from "./centerBottom.vue?vue&type=script&lang=js&"
import style0 from "./centerBottom.vue?vue&type=style&index=0&id=6c333e54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c333e54",
  null
  
)

export default component.exports